import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import appliance from '@/views/appliance'
import login from '@/views/login'
import loginIndex from '@/views/login/login.vue'
import personal from '@/views/personal'
import template from '@/views/personal/template'
import imgInfo from '@/components/imgInfo'
import appPay from '@/views/appPay/index.vue'
import recharge from '@/views/personal/recharge.vue'
import bill from '@/views/personal/bill.vue'
import paintings from '@/views/personal/paintings.vue'
import inviteIndex from '@/views/personal/invite'
import invite from '@/views/personal/invite/invite.vue'
import memberList from '@/views/personal/invite/memberList.vue'
import detail from '@/views/personal/invite/detail.vue'
import InviteCards from '@/views/personal/invite/InviteCards.vue'
import withdrawDeposit from '@/views/personal/invite/withdrawDeposit.vue'
import forgetPassword from '@/views/login/forgetPassword'
import userInfo from '@/views/personal/userInfo.vue'
import setPassword from '@/views/personal/setPassword.vue'
import editPassword from '@/views/personal/editPassword.vue'
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta:{title:'首页',keywords:'首页',loginFlag:true},
    children:[
      {
        path: '/appliance',
        name: 'appliance',
        component: appliance,
        meta:{title:'',keywords:'首页1',loginFlag:true},
        children:[  {
          path:'/appliancetemplate',
          name:'applianceTemplate',
          component:template
        },
        {
          path:'/appliancepersonal',
          name:'appliancepersonal',
          component:personal,
          meta:{title:'个人中心',keywords:'个人中心',loginFlag:false,},
        },
      ]
      },
      {
        path:'/imgInfo',
        name:'imgInfo',
        component:imgInfo,
        meta:{title:'作品详情',keywords:'作品详情'},
      },
      {
        path:'/personal',
        name:'personal',
        component:personal,
        meta:{title:'个人中心',keywords:'个人中心',loginFlag:false,},
      },
      {
        path:'/template',
        name:'template',
        component:template,
        children:[
          {
            path:'/recharge',
            name:'recharge',
            component:recharge,
            meta:{title:'会员充值',keywords:'会员充值',loginFlag:false,tipFlag:false,path:'/personal'},
          },
          {
            path:'/bill',
            name:'bill',
            component:bill,
            meta:{title:'账单明细',keywords:'账单明细',loginFlag:false,tipFlag:false,path:'/personal'},
          },
          {
            path:'/paintings',
            name:'paintings',
            component:paintings,
            meta:{title:'私人画夹',keywords:'私人画夹',loginFlag:false,tipFlag:false,path:'/personal'},
          },
          {
            path:'/userInfo',
            name:'userInfo',
            component:userInfo,
            meta:{title:'个人信息',keywords:'个人信息',loginFlag:false,tipFlag:false,path:'/personal'},
          },
          {
            path:'/setPassword',
            name:'setPassword',
            component:setPassword,
            meta:{title:'设置密码',keywords:'设置密码',loginFlag:false,tipFlag:false,path:'/userInfo'},
          },
          {
            path:'/editPassword',
            name:'editPassword',
            component:editPassword,
            meta:{title:'修改密码',keywords:'修改密码',loginFlag:false,tipFlag:false,path:'/userInfo'},
          },
          
          {
            path:'/inviteIndex',
            name:'inviteIndex',
            component:inviteIndex,
            redirect: "/invite",
            children:[
              {
                path:'/invite',
                name:'invite',
                component:invite,
                meta:{title:'邀请好友',keywords:'邀请好友',loginFlag:false,tipFlag:false,path:'/personal'},
              },
              {
                path:'/memberList',
                name:'memberList',
                component:memberList,
                meta:{title:'我的团员',keywords:'我的团员',loginFlag:false,tipFlag:false,path:'/invite'},
              },
              {
                path:'/detail',
                name:'detail',
                component:detail,
                meta:{title:'收支明细',keywords:'收支明细',loginFlag:false,tipFlag:false,path:'/invite'},
              },
              {
                path:'/InviteCards',
                name:'InviteCards',
                component:InviteCards,
                meta:{title:'我的邀请码',keywords:'我的邀请码',loginFlag:false,tipFlag:false,path:'/invite'},
              },
              {
                path:'/withdrawDeposit',
                name:'withdrawDeposit',
                component:withdrawDeposit,
                meta:{title:'提现',keywords:'提现',loginFlag:false,tipFlag:false,path:'/invite'},
              }
            ]
          }
        ]
      },
      {
        path: '/login',
        name: 'login',
        component: login,
        redirect: "/loginIndex",
        children:[
          {
            path:'/loginIndex',
            name:'loginIndex',
            component:loginIndex,
            meta:{title:'登录',keywords:'登录',loginFlag:false,tipFlag:false,path:'/login'},
          },
          {
            path:'/forgetPassword',
            name:'forgetPassword',
            component:forgetPassword,
            meta:{title:'忘记密码',keywords:'忘记密码',loginFlag:false,tipFlag:false,path:'/login'},
          }
        ]
      },
    ]
  },
  {
    path:'/appPay',
    name:'appPay',
    component:appPay,
    meta:{title:'充值',keywords:'充值'},
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
